import React from 'react';
import { NavLink } from 'react-router-dom';

var bnr1 = require('./../../images/background/bg-5.png');

class Specialization extends React.Component {
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding bg-white p-t80 p-b30 bg-repeat square_shape1" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                    {/* IMAGE CAROUSEL START */}
                    <div className="section-content">
                        <div className="row">
                            <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                                <div className="image-effect-one hover-shadow">
                                    <img src={require('../../images/pic1.jpg')} alt=""/>
                                    <div className="figcaption">
                                        <h4>Fire Detection</h4>
                                        <p>Stay alert, stay protected.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4  col-sm-6 m-b30">
                                <div className="image-effect-one hover-shadow">
                                    <img src={require('../../images/pic2.jpg')} alt="" />
                                    <div className="figcaption">
                                        <h4>Suppression Systems</h4>
                                        <p>Engineered to stop fire in its tracks.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4  col-sm-6 m-b30">
                                <div className="image-effect-one hover-shadow">
                                    <img src={require('../../images/pic3.jpg')} alt="" />
                                    <div className="figcaption bg-dark">
                                        <h4>Annual Maintenance</h4>
                                        <p>We don’t just install—we protect for life.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12 col-sm-6 m-b30">
                                <div className="mt-box our-speciallization-content">
                                    <h3 className="m-t0"><span className="font-weight-100">Protecting</span> <br />What matters most.</h3>
                                    <p>From homes to high-rises, we deliver trusted fire safety solutions that secure your spaces and give peace of mind.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                    <div className="hilite-title text-right p-r50 text-uppercase text-pop-up-top">
                        <strong>Welcome</strong>
                    </div>
                </div>
            </>
        );
    }
};

export default Specialization;